/* eslint-disable import/prefer-default-export */
import { LANGUAGE_SET } from './constants';
export function setLanguage(lang) {
  return { type: LANGUAGE_SET, lang };
}



// WEBPACK FOOTER //
// ./src/app/containers/Language/actions.js